<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <el-dialog
      title="发起结算"
      :visible.sync="dialogVisible"
      width="824px"
      :before-close="closeDialog"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="100px">
        <el-col :span="12">
          <el-form-item prop="contentName" label="收款内容:">
            <span>{{ params.contentName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="receivableDate" label="应收日期:">
            <el-date-picker
              v-model="params.receivableDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="receivableAmount" label="应收金额:">
            <span>{{ params.receivableAmount }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="plateNo" label="车牌号:">
            <span>{{ params.plateNo }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="付款方类型" prop="customerType">
            <el-select
              v-model="params.customerType"
              clearable
              placeholder="请选择"
              @change="getCustomerType"
            >
              <el-option
                v-for="item in customerTypeList"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="customerId" label="付款方">
            <el-select
              v-model="params.customerId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              clearable
              :remote-method="getPayCustomer"
              :loading="payerLoading"
              :disabled="params.customerType === 10 || !params.customerType"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.customerName"
                :value="item.id"
              >
                <CustomerNameOptionItem :data="item" />
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="remarks" label="备注:">
            <el-input
              v-model="params.remarks"
              type="textarea"
              maxlength="500"
              show-word-limit
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirm" v-submitDingTalkShow="19"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCollectCustomerList,
  accidentSettlementAddSignCheck,
} from '@/api/domain/carsService'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import selectOption from '@/store/dict/selectOptionDict'
import { submitDingTalkShow } from '@/directives/submitDingTalkShow'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'

export default {
  model: {
    prop: 'showDialog',
    event: 'change',
  },
  /** 钉钉审批流是否存在审批配置 2023/09/25 */
  directives: {
    submitDingTalkShow,
  },
  components: {
    CustomerNameOptionItem,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      payerLoading: false, // 付款方模糊筛选
      rules: {
        // 必填
        receivableDate: [
          { required: true, message: '应收日期不能为空', trigger: 'blur' },
        ],
        dueAmount: [
          { required: true, message: '应收金额不能为空', trigger: 'blur' },
        ],
        customerType: [
          { required: true, message: '付款方类型不能为空', trigger: 'blur' },
        ],
        customerId: [
          { required: true, message: '付款方不能为空', trigger: 'blur' },
        ],
        remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
      },
      customerList: [], // 付款方列表
    }
  },
  computed: {
    // 收付款方类型
    customerTypeList() {
      const result = {}
      for (const key in selectOption.customerTypeDict) {
        if (Object.hasOwnProperty.call(selectOption.customerTypeDict, key)) {
          // 非 【其他】类型的显示，其他模块涉及收付款方类型中的其他是否展示由产品输出
          if (Number(key) !== 10) {
            result[key] = selectOption.customerTypeDict[key]
          }
        }
      }
      return this.dictParseList(result)
    },
  },
  watch: {
    showDialog(val) {
      // 付款方回显
      this.getPayCustomer(this.params.customerName)
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('change', val)
    },
  },
  methods: {
    // 付款方下拉模糊
    async getPayCustomer(customerName) {
      if (customerName) {
        this.getCustomerList(customerName)
      }
    },
    async getCustomerList(customerName, params = {}) {
      this.payerLoading = true
      // 服务商：1
      // 客户: 2
      if (this.params.customerType === 1) {
        try {
          const { code, data } = await getCollectCustomerList({
            name: customerName,
            ...params,
          })
          if (code === 1) {
            // 关闭远程搜索
            this.customerList = data.items.map((item) => ({
              ...item,
              customerName: item.name,
              customerTel: item.contactTel,
            }))
          }
          this.payerLoading = false
        } catch (error) {
          this.payerLoading = false
        }
      } else if (this.params.customerType === 2) {
        try {
          const { code, data = [] } = await searchByCustomerNameSensitive({
            customerState: 1,
            customerName,
            mixedType: 'YES',
          })
          if (code === 1) {
            this.customerList = data
          }
          this.payerLoading = false
        } catch (error) {
          this.payerLoading = false
        }
      }
    },
    // 付款方类型change
    getCustomerType(val) {
      // 选中其他 不校验付款方
      if (val === 10) {
        delete this.rules.customerId
      }
      if (val !== 10) {
        this.rules.customerId = [
          { required: true, message: '付款方不能为空', trigger: 'blur' },
        ]
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.params.customerId = ''
      if (val) {
        this.getCustomerList('', {
          pageNum: 1,
          pageSize: 200,
        })
      }
    },
    // 取消
    closeDialog() {
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    // 确定
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          accidentSettlementAddSignCheck(this.params).then((res) => {
            const { code } = res
            if (code === 1) {
              const msg = this.DingTalkShow19 ? '提交审批成功' : '结算成功'
              this.$message.success(msg)
              this.closeDialog()
              this.$emit('paginationEvent')
            }
          })
        }
      })
    },
  },
}
</script>
